/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */
import { cssMap, jsx } from '@compiled/react';

import Avatar from '@atlaskit/avatar/avatar';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { token } from '@atlaskit/tokens';
import { useHubContext } from '@atlassian/company-hub-common/utils';

const styles = cssMap({
	displayName: {
		font: token('font.body'),
	},
	root: {
		paddingTop: token('space.100'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.200'),
		paddingRight: token('space.200'),
	},
	emailText: {
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		width: '100%',
		display: 'inline-block',
		maxWidth: '160px',
	},
});

export const AccountDetails = (): JSX.Element => {
	const { user } = useHubContext();
	const { avatarSrc, displayName, email } = user;

	return (
		<div css={styles.root}>
			<Inline alignBlock="center" space="space.100">
				<Flex alignItems="center" justifyContent="center" gap="space.100">
					<Avatar appearance="circle" size="medium" src={avatarSrc} />
				</Flex>
				<Stack>
					<div css={styles.displayName}>{displayName}</div>
					<small css={styles.emailText}>{email}</small>
				</Stack>
			</Inline>
		</div>
	);
};
